import { Modal as BaseModal } from '@components/moleculs/modal';
import styled from 'styled-components';

export const Modal = styled(BaseModal)`
    .MuiDialog-container > .MuiPaper-root {
        padding: 48px;
        max-width: 800px;

        ${(props) => props.theme.breakpointTo.md} {
            padding: 32px;
        }

        ${(props) => props.theme.breakpointTo.xs} {
            padding: 16px;
        }
    }

    .welcome-icon {
        width: 190px;

        ${(props) => props.theme.breakpointTo.md} {
            width: 150px;
        }
    }

    .title {
        margin-top: 32px;
        font-weight: 500;
        font-size: 28px;
        line-height: 40px;
        letter-spacing: -0.01em;

        ${(props) => props.theme.breakpointTo.md} {
            font-size: 20px;
            line-height: 28px;
        }
    }

    .description {
        margin-top: 32px;

        font-weight: 500;
        font-size: 20px;
        line-height: 30px;
        letter-spacing: -0.01em;
        color: ${(props) => props.theme.palette.textLight};

        ${(props) => props.theme.breakpointTo.md} {
            ${(props) => props.theme.typography.text}
        }
    }

    .notes {
        display: flex;
        margin-top: 32px;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0.002em;
        color: ${(props) => props.theme.palette.secondaryA8};

        ${(props) => props.theme.breakpointTo.md} {
            ${(props) => props.theme.typography.smallText}
        }
    }

    .info-icon {
        margin-right: 4px;
        min-width: 16.67px;
    }
`;
